module.exports = __webpack_public_path__ + "static/media/miasano-screen-two.451b0882.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/miasano-screen-two.png
// module id = 547
// module chunks = 0